// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "code-mirror" + "." + "ab65487c" + ".chunk.css";
};